export default "__VITE_ASSET__DbNy6XsB__"